var exports = {
  "Uo": "xdbfd91f1--fbb344--buttons",
  "x6": "xdbfd91f1--fbb344--button",
  "tY": "xdbfd91f1--fbb344--plus",
  "Rd": "xdbfd91f1--fbb344--minus",
};

module.exports = exports;
